import React, {useEffect, useMemo, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {fetchPcategories} from "../../../../../../reduxLib/pcategoriesLib";
import {fetchColorsByTextiles} from "../../../../../../reduxLib/colorsLib";
import {uploadProductImages} from "../../../../../../Utilities/uploadHelperProd";
import {createFile, deleteFile} from "../../../../../../reduxLib/filesPhLib";

export default function EditProductModal({ open, setOpen, product, onSubmit }) {

    const sizeMap = {
        "5": "Small",
        "4": "Medium",
        "3": "Large",
    };

    const buildDimensions = (w, h, d) => {
        const W = (w ?? "").toString().trim();
        const H = (h ?? "").toString().trim();
        const D = (d ?? "").toString().trim();
        if (!W || !H || !D) return null;
        return `${W}x${H}x${D} εκ.`;
    };

    const toNumberOrNull = (v) => {
        if (v === null || v === undefined) return null;
        const s = String(v).trim();
        if (s === "") return null;
        const n = Number(s);
        return Number.isFinite(n) ? n : null;
    };


    const dispatch = useDispatch();
    //categories fetch
    const [categoryOptions, setCategoryOptions] = useState([]);
    const catstate=useSelector((state)=> state.categoryreducer.state);
    const categories= useSelector((state)=> state.categoryreducer.pcategoriesList);
    const FILES_BASE_URL = ""; // ή άστο "" αν ήδη σερβίρονται σωστά

    const toFileUrl = (fileLocation) => {
        if (!fileLocation) return "";
        // αν είναι ήδη absolute
        if (/^https?:\/\//i.test(fileLocation)) return fileLocation;
        // αλλιώς κόλλα base
        return `${FILES_BASE_URL}${fileLocation}`;
    };


    const normalizeFilesRelated = (arr) => {
        if (!Array.isArray(arr)) return [];
        return arr
            .map((f) => ({
                file_ID: f.file_ID,
                name: f.name,
                fileType: f.fileType,
                fileLocation: f.fileLocation,
                url: toFileUrl(f.fileLocation),
            }))
            .filter((x) => !!x.url);
    };

    const normalizeColors = (arr) => {
        if (!Array.isArray(arr)) return [];
        return arr.map((c) => ({
            pcid: Number(c.pcid ?? c.id),
            colorName: c.colorName ?? c.ColorName ?? "Color",
            hexColor: c.hexColor ?? c.HexColor ?? "#ffffff",
            textiles: c.textiles ?? null,
        }));
    };

    const [filesRelated, setFilesRelated] = useState([]);
    const [uploadQueue, setUploadQueue] = useState([]); // νέα FilesRelated uploads (File objects)
    const [busyFileId, setBusyFileId] = useState(null); // optional loader

    const [colorsToRender, setColorsToRender] = useState([]);

    // Special Properties (controlled)
    const [textilesValue, setTextilesValue] = useState("");
    const [plexis, setPlexis] = useState("");
    const [closingTextiles, setClosingTextiles] = useState("");
    const [ConstructionEffortDays, setConstructionEffortDays] = useState("");
    const [productSize, setProductSize] = useState("");
    const [size, setSize] = useState("");

    const textilesStatus = useSelector((state) => state.colorreducer.textilesStatus);
    const textilesColor = useSelector((state) => state.colorreducer.textilesColor);

    const replaceInputRef = useRef(null);
    const replaceTargetRef = useRef(null);

    useEffect(() => {
        setFilesRelated(normalizeFilesRelated(product?.filesRelated ?? []));
        setTextilesValue(product?.textiles ?? "");
        setPlexis(product?.plexis ?? "");
        setClosingTextiles(product?.closingTextiles ?? "");
        setUploadQueue([]);
        setColorsToRender(product?.colors ?? []);
        setConstructionEffortDays(product?.constructionEffortDays ?? "");
        setProductSize(product?.productSize ?? "");
        setSize(product?.size ?? "");
    }, [product]);



    useEffect(()=>{

        if(!categories || categories.length === 0) {
            // Fetch the event by ID when the component mounts or when the id changes
            dispatch(fetchPcategories()).then((action) => {
                // Once the action is fulfilled, set the eventprofile state
                if (action.payload) {
                    setCategoryOptions(action.payload);
                    console.log("playload ", action.payload);
                    console.log("playload E", categoryOptions);
                }
            });
        }
        else {
            //let f=events.filter((event) => event.ownerid === id);
            // If the event data is already available, set the eventprofile state

            setCategoryOptions(categories);
            console.log("not disp ",categories);
        }
    }, [dispatch,catstate]);

    useEffect(() => {
        if (!productSize) {
            setSize("");
            return;
        }

        setSize(sizeMap[String(productSize)] ?? "");
    }, [productSize]);

    useEffect(() => {
        if (!textilesValue) {
            setColorsToRender([]);
            return;
        }

        // ίδιο textiles με product → κράτα product.colors
        if (textilesValue === (product?.textiles ?? "")) {
            setColorsToRender(product?.colors ?? []);
            return;
        }
        setColorsToRender([]); // ώστε να φαίνονται “unselected νέα” μόλις έρθουν
        // αλλιώς φέρε νέα colors από redux thunk
        dispatch(fetchColorsByTextiles(textilesValue));
    }, [textilesValue, product, dispatch]);

    useEffect(() => {
        if (!textilesValue) return;

        // ΜΟΝΟ όταν είναι διαφορετικό από του product (δηλ. ζητάμε νέα)
        if (textilesValue === (product?.textiles ?? "")) return;

        // όταν το thunk τελειώσει επιτυχώς, πάρε το payload
        if (textilesStatus === "success" || textilesStatus === "fulfilled") {
            setColorsToRender(textilesColor ?? []);
        }

        // αν αποτύχει, καθάρισε
        if (textilesStatus === "error" || textilesStatus === "rejected") {
            setColorsToRender([]);
        }
    }, [textilesValue, product, textilesStatus, textilesColor]);



    if (!open) return null;

// ---- Actions (UI state updates first) ----
// --- Delete (UI immediate) ---
    const handleDeleteFileRelated = async (item) => {
        setFilesRelated((prev) => prev.filter((x) => x.file_ID !== item.file_ID));
//missing disk handling(actual deletion)

        //delete metadata
        try {
            setBusyFileId(item.file_ID);
            const  action=await  dispatch(deleteFile(item.file_ID));
        }
        catch (e) {
            // rollback if you want
            setFilesRelated((prev) => [...prev, item]);
        }
        finally {
            setBusyFileId(null);
        }

        // OPTIONAL: backend delete
        // try {
        //   setBusyFileId(item.file_ID);
        //   await apiDeleteProductImage(item.file_ID);
        // } catch (e) {
        //   // rollback if you want
        //   setFilesRelated((prev) => [item, ...prev]);
        // } finally {
        //   setBusyFileId(null);
        // }
    };

// --- Replace flow ---
    const handleChooseReplaceFileRelated = (item) => {
        replaceTargetRef.current = item; // κρατάμε ποιο file_ID θα αντικαταστήσουμε
        replaceInputRef.current?.click();
    };

    const handleReplaceSelectedFileRelated = async (e) => {
        const file = e.target.files?.[0];
        const target = replaceTargetRef.current;
        e.target.value = ""; // allow choose same file again
        if (!file || !target) return;

        // UI preview immediately (χωρίς να περιμένουμε backend)
        const previewUrl = URL.createObjectURL(file);

        setFilesRelated((prev) =>
            prev.map((x) =>
                x.file_ID === target.file_ID
                    ? { ...x, url: previewUrl, _replacedFile: file } // κρατάμε το file για submit/API
                    : x
            )
        );

        // OPTIONAL: backend replace
        // try {
        //   setBusyFileId(target.file_ID);
        //   const newUrl = await apiReplaceProductImage(target.file_ID, file);
        //   setFilesRelated((prev) =>
        //     prev.map((x) =>
        //       x.file_ID === target.file_ID ? { ...x, url: newUrl, _replacedFile: undefined } : x
        //     )
        //   );
        // } finally {
        //   setBusyFileId(null);
        // }
    };

// --- Upload new images ---
    const handleAddUploadsFilesRelated = async (e) => {
        const files = Array.from(e.target.files ?? []);
        e.target.value = "";
        if (!files.length) return;

        setUploadQueue((prev) => [...prev, ...files]);
        let uploadedUrls = [];

        for (const file of uploadQueue) {
            const result = await uploadProductImages(
                product?.name || "product",
                file
            );

            if (Array.isArray(result?.urls)) {
                uploadedUrls.push(...result.urls);
            }
        }

        // εμφανίζουμε άμεσα preview items μέσα στο grid
        const tempItems = files.map((f, idx) => ({
            file_ID: `new-${Date.now()}-${idx}`, // temp id
            name: f.name,
            fileType: f.type,
            fileLocation: null,
            url: URL.createObjectURL(f),
            _newFile: f,
        }));

        for (let i = 0; i < uploadedUrls.length; i++) {
            const url = uploadedUrls[i];
            if (!url) continue;

            const filesCreator = {
                Name: `${product.name}-${i + 1}`,
                FileLocation: url,
                DateCreated: new Date(),
                fileType: "PRODUCT_IMAGE",
                productRelId: Number(product?.id), // δεν υπάρχει ακόμα product, άστο 0 (ή ό,τι δέχεται backend)
            };

            const action = await dispatch(createFile(filesCreator));

        }

        setFilesRelated((prev) => [...tempItems, ...prev]);
    };

    const handleRemoveNewUpload = (item) => {
        if (!item?._newFile) return;
        setUploadQueue((prev) => prev.filter((f) => f !== item._newFile));
        setFilesRelated((prev) => prev.filter((x) => x.file_ID !== item.file_ID));
    };

    const formDataToProductObject = (fd, { product, colorsToRender, filesRelated }) => {
        // Build a lookup for colors by pcid so we can return full objects
        const colorPool = [
            ...(Array.isArray(product?.colors) ? product.colors : []),
            ...(Array.isArray(colorsToRender) ? colorsToRender : []),
        ];
        const colorById = new Map(
            colorPool.map((c) => [Number(c.pcid ?? c.id), c]).filter(([id]) => Number.isFinite(id))
        );

        const selectedIds = (fd.getAll("selectedColorIds") ?? [])
            .map((x) => Number(x))
            .filter((n) => Number.isFinite(n));

        const selectedColors = selectedIds
            .map((id) => colorById.get(id))
            .filter(Boolean);

        const productSizeEnum = (fd.get("productSize") ?? "").toString(); // "5"/"4"/"3"
        const derivedSize = (fd.get("size") ?? "").toString(); // "Small/Medium/Large" (derived input)
        const descriptionText = (fd.get("description") ?? "").toString();
        const detailsText = (fd.get("details") ?? "").toString();

        const width = toNumberOrNull(fd.get("width"));
        const height = toNumberOrNull(fd.get("height"));
        const depth = toNumberOrNull(fd.get("depth"));

        const dimentions = buildDimensions(width, height, depth) ?? (product?.dimentions ?? null);

        // IMPORTANT:
        // - backend sample has BOTH "details" (long text) and "description" (short text).
        // - Your form currently has one textarea named "description".
        //   So we set both from the same input unless you later add a second field.
        const obj = {
            // IDs / basics
            productID: product?.productID,
            name: (fd.get("name") ?? "").toString(),

            // backend naming
            categoryRelId: toNumberOrNull(fd.get("category")) ?? product?.categoryRelId,

            details: detailsText,
            description: descriptionText,

            // numbers
            price: toNumberOrNull(fd.get("price")) ?? 0,
            constructionEffortDays:
                toNumberOrNull(fd.get("constructionEffortDays")) ?? product?.constructionEffortDays ?? null,
            rating: product?.rating ?? null,
            estimationDeliveryDays: product?.estimationDeliveryDays ?? null,

            // special props
            textiles: (fd.get("textiles") ?? "").toString() || null,
            plexis: (fd.get("plexis") ?? "").toString() || null,
            closingTextiles: (fd.get("closingTextiles") ?? "").toString() || null,

            // sizes (κρατάμε και τα 2 όπως στο sample σου)
            //productSize: sizeMap[productSizeEnum] ?? (product?.productSize ?? null), // "S/M/L"
            productSize: productSizeEnum,
            size: derivedSize || product?.size || null, // "Small/Medium/Large" ή ελληνικό, ό,τι θες

            // colors full objects (όπως το backend)
            colors: selectedColors,

            // images metadata (καθαρό, χωρίς _newFile/_replacedFile)
            filesRelated: (Array.isArray(filesRelated) ? filesRelated : []).map((f) => ({
                fileType: f.fileType ?? null,
                productRelId: f.productRelId ?? product?.productID ?? null,
                name: f.name ?? null,
                fileLocation: f.fileLocation ?? null,
                dateCreated: f.dateCreated ?? null,
                file_ID: typeof f.file_ID === "string" && f.file_ID.startsWith("new-") ? null : f.file_ID,
            })),

            // dimensions
            dimentions,

            // flags (μην τα χάσεις αν το backend τα περιμένει)
            isAvailable: product?.isAvailable ?? true,
            canBeOrdered: product?.canBeOrdered ?? true,
            isPopular: product?.isPopular ?? false,

            // keep dates if backend needs them
            dateAdded: product?.dateAdded ?? null,
        };

        // Extra: κρατάμε τα files για upload/replace ξεχωριστά (δεν μπαίνουν στο JSON)
        const newUploads = (Array.isArray(filesRelated) ? filesRelated : [])
            .filter((x) => x?._newFile)
            .map((x) => x._newFile);

        const replaced = (Array.isArray(filesRelated) ? filesRelated : [])
            .filter((x) => x?._replacedFile && x?.file_ID && !(String(x.file_ID).startsWith("new-")))
            .map((x) => ({ file_ID: x.file_ID, file: x._replacedFile }));

        return { obj, newUploads, replaced };
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);

        const { obj, newUploads, replaced } = formDataToProductObject(formData, {
            product,
            colorsToRender,
            filesRelated,
        });

        // εδώ στέλνεις JSON object (και αν θες, attachments δίπλα)
        onSubmit?.({ ...obj, _newUploads: newUploads, _replaced: replaced });

       // onSubmit?.(formData);
        setOpen(false);
    };

    return (
        <div
            className="modal fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            onClick={() => setOpen(false)}
        >
            <div
                className="bg-white rounded-lg p-8 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-2xl font-serif font-bold text-custom-green">
                        Edit Product
                    </h2>
                    <button onClick={() => setOpen(false)} className="text-gray-400 hover:text-gray-600">
                        <i className="fa-solid fa-times text-xl" />
                    </button>
                </div>

                <form className="space-y-6" onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">Product Name *</label>
                            <input
                                type="text"
                                name="name"
                                required
                                defaultValue={product?.name ?? ""}
                                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">Category *</label>
                            <select
                                name="category"
                                required
                                defaultValue={product?.categoryRelId ?? ""}
                                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                            >
                                <option value="">Select Category</option>
                                {/* εδώ ιδανικά κάνεις map από categories list */}
                                {categories.length > 0 ? (
                                    categories.map((c) => (
                                        <option key={c.categoryID ?? c.pid} value={c.categoryID ?? c.pid}>
                                            {c.name}
                                        </option>
                                    ))
                                ) : (
                                    <>
                                        <option value="-1">not found</option>
                                    </>
                                )}
                            </select>
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Description *</label>
                        <textarea
                            name="description"
                            rows={3}
                            required
                            defaultValue={product?.description ?? ""}
                            className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Details *</label>
                        <textarea
                            name="details"
                            rows={4}
                            required
                            defaultValue={product?.details ?? ""}
                            className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                        />
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">Price (€) *</label>
                            <input
                                type="number"
                                name="price"
                                step="0.01"
                                required
                                defaultValue={product?.price ?? ""}
                                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                            />
                        </div>
                    </div>
                    {/* Size + Dimensions */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Product Size (Enum)
                            </label>

                            <select
                                value={productSize}
                                onChange={(e) => setProductSize(e.target.value)}
                                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                            >
                                <option value="">Select</option>
                                <option value="5">Small</option>
                                <option value="4">Medium</option>
                                <option value="3">Large</option>
                            </select>

                            {/* για FormData */}
                            <input type="hidden" name="productSize" value={productSize} />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Size (Derived)
                            </label>

                            <input
                                type="text"
                                value={size}
                                readOnly
                                className="w-full px-3 py-2 border rounded-lg bg-gray-100 text-gray-600"
                            />

                            {/* για FormData */}
                            <input type="hidden" name="size" value={size} />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Dimensions (cm)
                            </label>
                            <div className="grid grid-cols-3 gap-2">
                                <input
                                    type="number"
                                    name="width"
                                    placeholder="Width"
                                    defaultValue={product?.width ?? ""}
                                    className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green"
                                />
                                <input
                                    type="number"
                                    name="height"
                                    placeholder="Height"
                                    defaultValue={product?.height ?? ""}
                                    className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green"
                                />
                                <input
                                    type="number"
                                    name="depth"
                                    placeholder="Depth"
                                    defaultValue={product?.depth ?? ""}
                                    className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green"
                                />
                            </div>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Construction Days
                            </label>

                            <input
                                type="number"
                                min="1"
                                value={ConstructionEffortDays}
                                onChange={(e) => setConstructionEffortDays(e.target.value)}
                                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                            />

                            {/* για να περάσει στο FormData χωρίς αλλαγή handleSubmit */}
                            <input
                                type="hidden"
                                name="constructionEffortDays"
                                value={ConstructionEffortDays}
                            />
                        </div>
                    </div>
                    {/* special props */}
                    <div className="border-t pt-6">
                        <h3 className="text-lg font-medium text-gray-900 mb-4">
                            Special Properties
                        </h3>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {/* textiles (drives colors) */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Textiles
                                </label>
                                <select
                                    value={textilesValue}
                                    onChange={(e) => setTextilesValue(e.target.value)}

                                    className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                                >
                                    <option value="">None</option>
                                    <option value="bambakero">bambakero</option>
                                    <option value="bambakeroLourex">bambakeroLourex</option>
                                    <option value="forte">forte</option>
                                </select>
                                <p className="text-xs text-gray-500 mt-1">
                                    Με βάση αυτό εμφανίζονται τα διαθέσιμα colors.
                                </p>
                            </div>

                            {/* plexis */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Plexis
                                </label>
                                <select
                                    value={plexis}
                                    onChange={(e) => setPlexis(e.target.value)}

                                    className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                                >
                                    <option value="">None</option>
                                    <option value="basic">basic</option>
                                    <option value="kagelaki">kagelaki</option>
                                    <option value="grammh">grammh</option>
                                    <option value="vafla">vafla</option>
                                </select>
                            </div>

                            {/* closing textiles */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Closing Textiles
                                </label>
                                <select
                                    value={closingTextiles}
                                    onChange={(e) => setClosingTextiles(e.target.value)}

                                    className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                                >
                                    <option value="">Δεν έχει</option>
                                    <option value="SIMPLE">Απλό</option>
                                    <option value="CABOURAS">Καβούρας</option>
                                    <option value="AXTIDA">Αχτίδα</option>
                                    <option value="TSOUREKI">Τσουρέκι</option>
                                </select>
                            </div>
                        </div>

                        {/* 🔒 χωρίς αλλαγές στο handleSubmit: hidden inputs για να πάνε στο FormData */}
                        <input type="hidden" name="textiles" value={textilesValue} />
                        <input type="hidden" name="plexis" value={plexis} />
                        <input type="hidden" name="closingTextiles" value={closingTextiles} />
                    </div>


                    {/* Colors (based on your backend: product.colors[]) */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Available Colors
                        </label>

                        <div className="grid grid-cols-4 md:grid-cols-6 gap-3 max-h-40 overflow-y-auto p-2 border rounded-lg">
                            {(colorsToRender ?? []).map((c) => {
                                const id = Number(c.pcid ?? c.id);
                                // ✅ Αν είναι τα original product colors → checked
                                const isOriginalProductTextiles =
                                    textilesValue === (product?.textiles ?? "");
                                return (
                                    <label key={id} className="flex flex-col items-center cursor-pointer">
                                        <input
                                            type="checkbox"
                                            name="selectedColorIds"
                                            value={id}
                                            defaultChecked={isOriginalProductTextiles}
                                            className="mb-1"
                                        />
                                        <div
                                            className="w-8 h-8 rounded-full border-2"
                                            style={{ backgroundColor: c.hexColor ?? c.hex ?? "#ffffff" }}
                                            title={c.colorName ?? c.ColorName ?? ""}
                                        />
                                        <span className="text-[11px] mt-1 text-center leading-tight">
                    {c.colorName ?? c.ColorName ?? "Color"}
                  </span>
                                    </label>
                                );
                            })}

                            {/* fallback αν δεν έχει colors */}
                            {(colorsToRender ?? []).length === 0 && (
                                <div className="col-span-full text-sm text-gray-500 p-2">
                                    No colors found for this product.
                                </div>
                            )}
                        </div>
                    </div>


                    {/* Product Images (filesRelated) */}
                    <div className="space-y-3">
                        <div className="flex items-center justify-between">
                            <label className="block text-sm font-medium text-gray-700">
                                Product Images
                            </label>
                            <span className="text-xs text-gray-500">
      {filesRelated.length} total
    </span>
                        </div>

                        {/* hidden input για replace */}
                        <input
                            ref={replaceInputRef}
                            type="file"
                            accept="image/*"
                            className="hidden"
                            onChange={handleReplaceSelectedFileRelated}
                        />

                        {/* thumbnails */}
                        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-3">
                            {filesRelated.map((img) => {
                                const isNew = !!img._newFile;
                                const isBusy = busyFileId === img.file_ID;

                                return (
                                    <div key={img.file_ID} className="border rounded-lg overflow-hidden bg-white">
                                        <div className="aspect-square bg-gray-50 relative">
                                            <img
                                                src={img.url}
                                                alt={img.name ?? ""}
                                                className="w-full h-full object-cover"
                                                draggable={false}
                                            />

                                            {isBusy && (
                                                <div className="absolute inset-0 bg-white/70 flex items-center justify-center text-xs">
                                                    Working...
                                                </div>
                                            )}

                                            {isNew && (
                                                <div className="absolute top-1 left-1 text-[10px] bg-black/70 text-white px-2 py-0.5 rounded">
                                                    NEW
                                                </div>
                                            )}
                                        </div>

                                        <div className="p-2">
                                            <div className="text-[11px] text-gray-600 truncate" title={img.name ?? ""}>
                                                {img.name ?? "Image"}
                                            </div>

                                            <div className="mt-2 flex gap-2">
                                                {!isNew ? (
                                                    <>
                                                        <button
                                                            type="button"
                                                            onClick={() => handleDeleteFileRelated(img)}
                                                            className="flex-1 px-2 py-1 text-xs border rounded hover:bg-gray-50"
                                                        >
                                                            Delete
                                                        </button>
                                                    </>
                                                ) : (
                                                    <button
                                                        type="button"
                                                        onClick={() => handleRemoveNewUpload(img)}
                                                        className="w-full px-2 py-1 text-xs border rounded hover:bg-gray-50"
                                                    >
                                                        Remove
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}

                            {filesRelated.length === 0 && (
                                <div className="col-span-full text-sm text-gray-500 border rounded-lg p-4">
                                    No images yet.
                                </div>
                            )}
                        </div>

                        {/* Upload new images */}
                        <label className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center cursor-pointer block hover:border-custom-green">
                            <i className="fa-solid fa-cloud-upload-alt text-3xl text-gray-400 mb-2" />
                            <p className="text-gray-600">Upload images</p>
                            <p className="text-xs text-gray-500 mt-1">Upload multiple images if needed</p>

                            {/* κρατάμε ΤΟ ΙΔΙΟ naming που έχεις */}
                            <input
                                type="file"
                                name="FilesRelated"
                                multiple
                                accept="image/*"
                                className="hidden"
                                onChange={handleAddUploadsFilesRelated}
                            />
                        </label>
                    </div>

                    <div className="flex justify-end space-x-4 pt-4">
                        <button
                            type="button"
                            onClick={() => setOpen(false)}
                            className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                        >
                            Cancel
                        </button>

                        <button
                            type="submit"
                            className="px-6 py-2 bg-custom-green text-white rounded-lg hover:bg-opacity-90"
                        >
                            Save Changes
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
